export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Montant"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Résultat"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Transaction"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Actualiser le statut"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Liens utiles"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Blockchain :"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En cours"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Succès"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Échoué"])}
}